module.exports = __webpack_public_path__ + "img/Alexander-Nevsky-Cathedral-Sofia.f02403ef.jpg";